// Shared "phone layout" predicate. A phone layout is any narrow window
// (≤979px — phones, narrow browser windows) plus every coarse-pointer,
// non-hover touch device at any width — tablets (iPad/Android) use the
// phone layout in portrait and landscape alike. Touch laptops that still
// report hover capability keep the desktop split layout at every width.
// Keep this query in sync with the phone-layout media blocks in
// web-app/src/styles.css.
const PHONE_LAYOUT_QUERY = "(max-width: 979px), (pointer: coarse) and (hover: none)";

export function isPhoneLayout(): boolean {
  return typeof window !== "undefined" && window.matchMedia(PHONE_LAYOUT_QUERY).matches;
}

export function watchPhoneLayout(handler: () => void): () => void {
  const media = window.matchMedia(PHONE_LAYOUT_QUERY);
  const sync = () => handler();
  media.addEventListener("change", sync);
  return () => media.removeEventListener("change", sync);
}
